module.exports = __webpack_public_path__ + "img/logos_mobile_7.0422abf1.png";